"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTabs = exports.MuiTab = void 0;
var colors_1 = require("../colors");
var system_1 = require("@mui/system");
var breakpoints = (0, system_1.createBreakpoints)({
    values: {
        xs: 0,
        sm: 361,
        md: 768,
        lg: 960,
        xl: 1200,
    },
});
exports.MuiTab = {
    styleOverrides: {
        root: (_a = {
                color: '#000',
                fontSize: 14,
                fontWeight: 500,
                minWidth: 50,
                textTransform: 'none'
            },
            _a[breakpoints.up('sm')] = { minWidth: 50 },
            _a['&:focus-visible, &.Mui-focusVisible'] = {
                backgroundColor: colors_1.tannerGray['100'],
                outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                outlineOffset: '-3px',
                borderRadius: '3px',
            },
            _a['&:hover'] = {
                backgroundColor: colors_1.tannerGray[50],
            },
            _a['&.Mui-selected'] = {
                color: colors_1.tannerBlack,
            },
            _a['&:active'] = {
                backgroundColor: colors_1.tannerGray[100],
            },
            _a),
        textColorInherit: {
            opacity: 1,
        },
    },
};
exports.MuiTabs = {
    defaultProps: {
        indicatorColor: 'primary',
    },
    styleOverrides: {
        root: {
            borderBottom: "1px solid ".concat(colors_1.tannerGray['200']),
        },
        scrollButtons: {
            '&.Mui-disabled': {
                opacity: 0.3,
            },
        },
        indicator: {
            height: 4,
        },
    },
};
//# sourceMappingURL=MuiTab.js.map